import { InferValueTypes } from "../service-types";
import * as actions from "./actions";

export enum ScopeErrorAction {
  SET_SCOPE_ERROR = "SET_SCOPE_ERROR",
  CLEAN_SCOPE_ERROR = "CLEAN_SCOPE_ERROR",
  CLEAN_UP_SCOPE_ERROR = "CLEAN_UP_SCOPE_ERROR",
}
export interface ApiError {
  statusCode: number;
  error: string;
  message: string;
  errors?: { [key: string]: string | string[] };
  timestamp?: string;
  path?: string;
}

export type ScopeErrorState = Readonly<{
  [key: string]: ApiError;
}>;

export type ScopeErrorActionTypes = ReturnType<InferValueTypes<typeof actions>>;
